import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

export const containerStyles: SystemStyleObject = {
  alignItems: 'center',
  display: 'flex',
  gap: '8px',
  mt: '8px',
  w: '100%',
}

/**
 * Play/pause button styles. `isPlaying` swaps the resting appearance to the
 * "active" look and suppresses the hover/active affordances (the control reads
 * as engaged rather than clickable).
 */
export const playButtonStyles = (
  colorScheme: ColorScheme,
  isPlaying: boolean
): SystemStyleObject => {
  const isDark = colorScheme === 'dark'
  const activeBg = isDark
    ? 'bg.tab-active'
    : 'light.interactive.tertiary-hover-bg'

  return {
    alignItems: 'center',
    bg: isPlaying ? activeBg : undefined,
    border: '1px solid',
    borderColor: isDark ? 'border.subtle' : 'light.border.subtle',
    color: isPlaying
      ? isDark
        ? 'icon.active'
        : 'light.icon.secondary'
      : isDark
      ? 'icon.secondary'
      : 'light.icon.secondary',
    cursor: 'pointer',
    display: 'flex',
    flexShrink: 0,
    h: '36px',
    justifyContent: 'center',
    transition:
      'background 0.15s ease, border-color 0.15s ease, color 0.15s ease',
    w: '36px',
    _hover: isPlaying
      ? {}
      : {
          bg: isDark
            ? 'interactive.tertiary-hover-bg'
            : 'light.interactive.tertiary-hover-bg',
          borderColor: isDark ? 'interactive.tertiary-hover-border' : undefined,
          color: isDark ? 'icon.primary' : undefined,
        },
    _active: isPlaying
      ? {}
      : {
          bg: activeBg,
          color: isDark ? 'icon.active' : undefined,
        },
  }
}
